/** @file What is under a screen point: the bone pickBone finds, else the top-most slot pickSlot finds. */
import { pickBone } from '@pose2d/editor-geometry/pickBone';
import { pickSlot } from '@pose2d/editor-geometry/pickSlot';
import type { ToolContext } from './viewportTypes';
import { worldAt } from './worldAt';

/** Data indices; -1 when nothing of that kind is hit (a bone hit leaves `slot` at -1). */
export function pickAt(ctx: Pick<ToolContext, 'pose' | 'data' | 'maps' | 'camera' | 'skeleton'>, sx: number, sy: number): { bone: number; slot: number } {
  const hit = pickBone({ world: ctx.pose.world, bones: ctx.data.bones, camera: ctx.camera, pickable: ctx.maps.pickable }, sx, sy);
  if (hit !== null) return { bone: hit.bone, slot: -1 };
  const w = worldAt(ctx, { sx, sy });
  return { bone: -1, slot: pickSlot(ctx.skeleton, w[0], w[1])?.slot ?? -1 };
}
